import React, { useState } from "react";
import FixaSearch from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";
import { Group } from "../types/groups";
import { useTranslation } from "@coworker/locales";
import { includesCaseInsensitive, removeAccents } from "../../../helpers/utils";

interface GroupSearchBarProps {
  groups: Group[];
  onSearchResults: (isSearchResult: boolean, results: Group[]) => void;
}

export const GroupSearchBar = ({
  groups,
  onSearchResults,
}: GroupSearchBarProps) => {
  const [searchInput, setSearchInput] = useState("");
  const { t } = useTranslation();

  const handleSearch = (value: string) => {
    const sanitizedValue: string = removeAccents(value.replace(/[.,\s]/g, ""));
    setSearchInput(value);

    if (!groups) return;

    // If search is empty, return all groups
    if (!sanitizedValue) {
      onSearchResults(false, groups);
      return;
    }

    onSearchResults(
      true,
      groups.filter(
        (group) =>
          includesCaseInsensitive(
            removeAccents(group.name).replace(/[.,\s]/g, ""),
            sanitizedValue
          ) ||
          includesCaseInsensitive(
            removeAccents(group.description).replace(/[.,\s]/g, ""),
            sanitizedValue
          )
      )
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(e.target.value);
  };

  const handleClear = () => {
    handleSearch("");
  };

  return (
    <FixaSearch
      id="group-search"
      value={searchInput}
      onChange={handleChange}
      onClear={handleClear}
      placeholder={t("searchBasicString")}
      data-testid="group-search-testid"
    />
  );
};
